import { render, staticRenderFns } from "./AvatarBuilderMainPreview.vue?vue&type=template&id=8dbd44e4&scoped=true&"
import script from "./AvatarBuilderMainPreview.vue?vue&type=script&lang=js&"
export * from "./AvatarBuilderMainPreview.vue?vue&type=script&lang=js&"
import style0 from "./AvatarBuilderMainPreview.vue?vue&type=style&index=0&id=8dbd44e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbd44e4",
  null
  
)

export default component.exports